export default {
  choiceMode: 'checkbox',
  choicePrefix: 'letters',
  choices: [],
  choicesLayout: 'vertical',
  feedbackEnabled: false,
  gridColumns: 2,
  lockChoiceOrder: true,
  partialScoring: true,
  prompt: '',
  promptEnabled: true,
  rationale: '',
  rationaleEnabled: true,
  scoringType: 'auto',
  studentInstructionsEnabled: true,
  teacherInstructions: '',
  teacherInstructionsEnabled: true,
  toolbarEditorPosition: 'bottom',
  selectedAnswerBackgroundColor: 'initial',
  selectedAnswerStrokeColor: 'initial',
  selectedAnswerStrokeWidth: 'initial',
  hoverAnswerBackgroundColor: 'initial',
  hoverAnswerStrokeColor: 'initial',
  hoverAnswerStrokeWidth: 'initial',
  keyboardEventsEnabled: false,
};
